export default __webpack_public_path__ + "static/media/ic1.07942bad.svg";